import axios from "axios";
import {
    getContactsSuccess,
    getContactsFail,
    getContactByIdSuccess,
    getContactByIdFail,
    updateNotesSuccess,
    updateNotesFail,
    updateContactsSuccess,
    updateContactsFail, 
    resetContactDetailsData,
    getSearchContactFail,
    getSearchcontactSuccess
} from "../constant";
import { Api } from "../../Config/config.js";
import { store } from "../store";

export const ContactsAction = async (dispatch, accountID, params) => {
  try {
    const response = await axios.get(`${Api}contacts`, {
      params: {
        accountID: accountID,
        sortBy: "-createdAt",
        ...params,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "Bearer " + store.getState().authReducer.tokens.access.token,
      },
    });

    dispatch({
      type: getContactsSuccess,
      payload: response.data,
    });

    return { success: true };
  } catch (error) {
    dispatch({
      type: getContactsFail,
      payload: error.response.data,
    });

    return { success: false };
  }
};

export const contactDetailAction = async (dispatch, id) => {
  try {
    const response = await axios.get(`${Api}contacts/${id}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "Bearer " + store.getState().authReducer.tokens.access.token,
      },
    });

    dispatch({
      type: getContactByIdSuccess,
      payload: response.data,
    });

    return { success: true };
  } catch (error) {
    dispatch({
      type: getContactByIdFail,
      payload: error.response.data,
    });

    return { success: false }; // Return failure status
  }
};

export const updateNotesAction = async (dispatch, id, notes) => {
  try {
    const response = await axios.patch(`${Api}contacts/${id}/notes`, notes, {
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "Bearer " + store.getState().authReducer.tokens.access.token,
      },
    });

    dispatch({
      type: updateNotesSuccess,
      payload: response.data,
    });

    return { success: true };
  } catch (error) {
    dispatch({
      type: updateNotesFail,
      payload: error.response.data,
    });

    return { success: false };
  }
};

export const updateContactsAction = async (dispatch, id, notes) => {
  try {
    const response = await axios.put(`${Api}contacts/${id}`, notes, {
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "Bearer " + store.getState().authReducer.tokens.access.token,
      },
    });

    dispatch({
      type: updateContactsSuccess,
      payload: response.data,
    });

    return { success: true };
  } catch (error) {
    dispatch({
      type: updateContactsFail,
      payload: error.response.data,
    });

    return { success: false };
  }
};

export const searchContact = async (dispatch, search, accountID,signal) => {
  try {
    const response = await axios.get(`${Api}contacts/search?search=${search}`, {
      params: {
        accountID: accountID
      },
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + store.getState().authReducer.tokens.access.token
      },
      signal: signal 
    },);

    dispatch({
      type: getSearchcontactSuccess,
      payload: response.data,
    });

    return { success: true };
  } catch (error) {
    if (axios.isCancel(error)) {
      console.log('Request canceled:', error.message);
    } else {
    dispatch({
      type: getSearchContactFail,
      payload: error.response.data,
    });
  }
    return { success: false };
  }
};

export const ResetContactDataAction = async (dispatch) => {
  dispatch({
    type: resetContactDetailsData,
  });
};